import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { LinearProgress } from '@mui/material'
import { userApiSlice } from '../../../features/user/userSlice'
import { H3 } from '../../../layouts/TextStyles'
import { managerApi } from '../../../features/manager/manager'
import { MODERATOR, SELLER } from '../../../utils/constants'
import ManagersTable from './components/ManagersTable'
import AddManagerDialog from './components/AddManagerDialog'
import { Content, Header, Title, Wrapper } from './styles'

const ManagerListPage = () => {
    const { formatMessage } = useIntl()
    const [searchParams, setSearchParams] = useSearchParams('')
    const [page, setPage] = React.useState(+searchParams.get('page') || 1)
    const [rowsPerPage, setRowsPerPage] = React.useState(
        +searchParams.get('size') || 5,
    )
    const {
        data: managerResponse = null,
        isFetching,
        refetch,
    } = managerApi.useFetchAllManagersQuery({
        page: +page - 1,
        size: +rowsPerPage,
        roles: [SELLER, MODERATOR],
    })
    const [deleteManager, { isLoading: isDeleting }] =
        managerApi.useDeleteManagerMutation()
    const [resetTemporaryPassword, { isLoading: isReseting }] =
        userApiSlice.useResetTemporaryPasswordMutation()
    const isLoading = isFetching || isReseting || isDeleting

    const handleDelete = async (id: number) => {
        try {
            await deleteManager(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (error) {}
    }

    const handleResetPassword = async (id: number) => {
        try {
            await resetTemporaryPassword(id).unwrap()
            toast.success(formatMessage({ id: 'savedSuccess' }))
            refetch()
        } catch (error) {}
    }

    useEffect(() => {
        const params = {
            page: page.toString(),
            size: rowsPerPage.toString(),
        }
        setSearchParams(params)
    }, [rowsPerPage, page])

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'managers' })}</H3>
                    </Title>

                    <AddManagerDialog />
                </Header>

                {isLoading ? (
                    <LinearProgress />
                ) : (
                    managerResponse && (
                        <ManagersTable
                            isFetching={isFetching || isReseting}
                            managersData={managerResponse.data}
                            pageNumber={managerResponse.pageNumber}
                            totalCount={managerResponse.totalCount}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                            onDelete={handleDelete}
                            onResetPassword={handleResetPassword}
                        />
                    )
                )}
            </Content>
        </Wrapper>
    )
}

export default ManagerListPage
